import React from 'react';
import { Container } from 'react-smooth-dnd';
import './DragAndDrop.css';
import ItemToDraggableMapper from './ItemToDraggableMapper/ItemToDraggableMapper';
import { GetOnDropHandle, GetOnDragStartHandle, GetOnDragEndFunctionHandle } from './helpers/isDraggingHelpers';

function GetPlaceholderAndContainerStyle(props) {
    let placeholder;
    if (props.items && props.items.length > 0) {
        placeholder = null;
    } else {
        placeholder = props.placeholder;
    }
    
    let minHeight;
    if (placeholder) {
        minHeight = props.minHeight;
    } else {
        minHeight = null;
    }
    
    const containerStyle = { minHeight: minHeight, flexGrow: props.flexGrow };
    
    return {
        placeholder: placeholder,
        containerStyle: containerStyle
    };
}

const DragAndDrop = (props) => {
    const { placeholder, containerStyle } = GetPlaceholderAndContainerStyle(props);
   
    const list = React.createRef();
    return (
        <ul
            ref={list}
            className={props.containerClass}
            data-placeholder={placeholder}
        >
            <Container
                behaviour={props.type}
                style={setListStyle(props,containerStyle)}
                groupName={props.groupName}
                getChildPayload={i => props.items[i]}
                onDrop={GetOnDropHandle(props)}
                onDragStart={GetOnDragStartHandle(props, list)}
                onDragEnd={GetOnDragEndFunctionHandle(props, list)}
                onDragEnter={() => props.handleDragEnter(list)}
                onDragLeave={() => props.handleDragLeave(list)}
            >
                <ItemToDraggableMapper {...props}/>
            </Container>
        </ul>
    );
}

function shouldApplyMinHeight(props) {
    const isMainBodySortableList = props.listName === 'mainBody' && props.containerClass === 'sortable-list';
    if (!isMainBodySortableList) {
        return false;
    }

    const isEmpty = props.items.length === 0;
    const hasSingleSpecialItem = props.items.length === 1 && 
        ['newsletter-3', 'widget-1', 'widget-2'].includes(props.items[0].id);

    return isEmpty || hasSingleSpecialItem;
}

function setListStyle(props, containerStyle) {
    if (shouldApplyMinHeight(props)) {
        containerStyle.minHeight = "calc(47vh - 30px)";
    }
    return containerStyle;
}

export default DragAndDrop;


